import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ButtonStyle = styled.div`
  margin-top: 2rem;
  .button {
    font-size: 2.2rem;
    padding: 0.7em 2em;
    // border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
    z-index: 1;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    // box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    //   7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
      -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
      inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),
      inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
    outline: none;
    transition: all 0.3s ease;
    overflow: hidden;
  }
  .button:after {
    position: absolute;
    content: ' ';
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) =>
      props.outline ? 'transperant' : 'var(--deep-dark)'};
    transition: all 0.3s ease;
  }
  .button:hover {
    background: transparent;
    // box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
    //   -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    //   inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),
    //   inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
    box-shadow: 0 0 12px rgba(95, 158, 160, 0.6),
      0 0 32px rgba(127, 179, 200, 0.4);
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
  }
  .button:hover:after {
    -webkit-transform: scale(2) rotate(180deg);
    transform: scale(2) rotate(180deg);
    // box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.5),
    //   -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    //   inset -4px -4px 6px 0 rgba(255, 255, 255, 0.5),
    //   inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
    box-shadow: 0 0 12px rgba(95, 158, 160, 0.6),
      0 0 32px rgba(127, 179, 200, 0.4);
  }

  @media only screen and (max-width: 768px) {
    .button {
      font-size: 1.8rem;
    }
  }
`;

export default function Button({
  btnText = 'test',
  btnLink = 'test',
  outline = false,
}) {
  return (
    <ButtonStyle outline={outline} className="button-wrapper">
      <Link className="button" to={btnLink}>
        {btnText}
      </Link>
    </ButtonStyle>
  );
}
